export const LANGUAGE_STORAGE_KEY = 'cranford-language';

export const LANGUAGES = [
  { code: 'en', flag: '🇨🇦', nativeName: 'English (Canada)', htmlLang: 'en-CA', ogLocale: 'en_CA' },
  { code: 'en-US', flag: '🇺🇸', nativeName: 'English (United States)', htmlLang: 'en-US', ogLocale: 'en_US' },
  { code: 'en-GB', flag: '🇬🇧', nativeName: 'English (United Kingdom)', htmlLang: 'en-GB', ogLocale: 'en_GB' },
  { code: 'fr-CA', flag: '🇨🇦', nativeName: 'Français (Canada)', htmlLang: 'fr-CA', ogLocale: 'fr_CA' },
  { code: 'fr-FR', flag: '🇫🇷', nativeName: 'Français (France)', htmlLang: 'fr-FR', ogLocale: 'fr_FR' },
  { code: 'de', flag: '🇩🇪', nativeName: 'Deutsch', htmlLang: 'de-DE', ogLocale: 'de_DE' },
  // Beta: site chrome is translated, page bodies still fall back to English and
  // the wording has not been reviewed by a fluent speaker yet.
  { code: 'ga', flag: '🇮🇪', nativeName: 'Gaeilge', htmlLang: 'ga-IE', ogLocale: 'ga_IE', beta: true },
  {
    code: 'gd',
    flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    nativeName: 'Gàidhlig',
    htmlLang: 'gd-GB',
    ogLocale: 'gd_GB',
    beta: true,
  },
];

const VALID = new Set(LANGUAGES.map((l) => l.code));

export function getLanguageByCode(code) {
  return LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
}

/** Map navigator.language / navigator.languages to a supported locale. */
export function detectBrowserLanguage() {
  const candidates = [];
  if (typeof navigator !== 'undefined') {
    if (Array.isArray(navigator.languages)) candidates.push(...navigator.languages);
    if (navigator.language) candidates.push(navigator.language);
  }

  for (const raw of candidates) {
    const tag = String(raw || '').trim().replace('_', '-');
    if (!tag) continue;
    const lower = tag.toLowerCase();
    if (lower === 'fr-ca' || lower.startsWith('fr-ca') || lower === 'fr-qc') return 'fr-CA';
    if (lower.startsWith('fr')) return 'fr-FR';
    if (lower.startsWith('de')) return 'de';
    if (lower.startsWith('ga')) return 'ga';
    if (lower.startsWith('gd')) return 'gd';
    // Any English locale (US, GB, AU, IE, …) defaults to Canadian English.
    // Visitors can still pick US/UK in the language menu.
    if (lower.startsWith('en')) return 'en';
  }
  return 'en';
}

export function readStoredLanguage() {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && VALID.has(stored)) return stored;
  } catch {
    /* ignore */
  }
  return null;
}

export function persistLanguage(code) {
  try {
    if (VALID.has(code)) localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
  } catch {
    /* ignore */
  }
}
